import script from "./ProductBarcode.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBarcode.vue?vue&type=script&setup=true&lang=js"

import "./ProductBarcode.vue?vue&type=style&index=0&id=d12e4a70&lang=css"

const __exports__ = script;

export default __exports__